import React, { useState } from "react";
import Callout from "components/Callout";
import PricesSelect from "./PricesSelect";
import { BUTTON_CLASS_CONTEXT, secondaryBackButton } from "utils/constants/ui";
import HoverIconButton from "components/HoverIconButton";
import PricesCurrencySelect from "components/PricesCurrencySelect";
import Toggle from "react-toggle";
import { getToggleProps } from "utils/form";
import Button from "components/Form/fields/Button";
import { PRODUCT_PRICE_INTENT } from "utils/constants/pricing";
import {
  filterProductPricesStatusCurrency,
  getInitialActiveCurrency,
  getPriceForCurrencyLocale
} from "utils/price";
import { useIsAuthed } from "utils/selectors";

const AllProductPrices = ({
  uid,
  goBack,
  onSelect,
  activePrices,
  product,
  setActiveSection
}) => {
  /**
   * If the user is authed they can create a new price for a product
   * - we allow them to update intent so that they can see the new price menu
   */
  const isAuthed = useIsAuthed();
  const priceForCurrency = getPriceForCurrencyLocale(product.prices);
  const [activeCurrency, setActiveCurrency] = useState(
    getInitialActiveCurrency({
      price: priceForCurrency,
      product: product
    })
  );
  const [showInactive, setShowInactive] = useState(false);
  const productPrices = filterProductPricesStatusCurrency({
    productUid: uid,
    prices: product.prices,
    currency: activeCurrency,
    showInactive
  });

  const hasInactive = product.prices.find(({ active }) => !active);
  const buttonProps = secondaryBackButton({
    onClick: goBack,
    tooltip: "Change product"
  });

  return (
    <div className="flex flex-column w-100">
      <div className="flex flex-column flex-row-ns justify-between items-center-ns">
        <div className="flex flex-row items-center">
          <HoverIconButton {...buttonProps} />
          <div className="pl1 f4 pl2-ns fw6">{product.name}</div>
        </div>
        <div className="flex flex-row items-center justify-between justify-end-ns pt3 pt0-ns">
          <PricesCurrencySelect
            hideLabel
            customClasses={{ container: "pr2" }}
            selectProps={{
              customClasses: {
                input:
                  "border-box input-reset ba br2 b--black-20 pa2 db w-100 pointer shadow-0"
              }
            }}
            prices={product.prices}
            value={activeCurrency}
            setActiveCurrency={setActiveCurrency}
          />
          {isAuthed && (
            <Button
              theme="slim"
              classes={{
                contextClass: BUTTON_CLASS_CONTEXT.SECONDARY
              }}
              onClick={() => setActiveSection(PRODUCT_PRICE_INTENT.NEW_PRICE)}
              copy="Create price"
            />
          )}
        </div>
      </div>
      {hasInactive && (
        <div className="pt3 flex flex-row justify-between items-center">
          <label className="f6 fw5 db">Show inactive prices</label>
          <Toggle
            {...getToggleProps({
              active: showInactive,
              setFieldValue: (_, active) => setShowInactive(active)
            })}
          />
        </div>
      )}
      {productPrices.length ? (
        //  Note: also by another name ProductPricesIndex in ProductForm/ProductPrices
        <PricesSelect
          onSelect={onSelect}
          prices={productPrices}
          activePrices={activePrices}
        />
      ) : (
        <div className="pt3">
          <Callout
            copy="No product prices available."
            customClasses={{
              container:
                "flex ph2 ba br2 items-center b--black-10 pv2 w-100 justify-between"
            }}
          />
        </div>
      )}
    </div>
  );
};

export default AllProductPrices;
